import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { articles } from "../lib/content";

export const ArticlesGrid = ({ limit, heading = "Hydration field notes." }) => {
    const list = limit ? articles.slice(0, limit) : articles;

    return (
        <section className="border-t border-foreground py-16 sm:py-24" data-testid="articles-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
                <div className="flex items-end justify-between flex-wrap gap-6 mb-10">
                    <div>
                        <div className="editorial-label mb-3">Blog</div>
                        <h2 className="text-4xl sm:text-5xl font-black tracking-tighter max-w-2xl">{heading}</h2>
                    </div>
                    {limit && (
                        <Link
                            to="/blog"
                            data-testid="see-all-articles"
                            className="btn-outline-editorial"
                        >
                            See all articles
                        </Link>
                    )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-foreground border border-foreground">
                    {list.map((a, i) => (
                        <Link
                            key={a.slug}
                            to={`/blog/${a.slug}`}
                            data-testid={`article-card-${i}`}
                            className="group bg-card flex flex-col"
                        >
                            <div className="aspect-[16/10] overflow-hidden border-b border-foreground bg-secondary">
                                <img
                                    src={a.cover}
                                    alt={a.title}
                                    loading="lazy"
                                    className="w-full h-full object-cover transition-all duration-300 group-hover:scale-105 grayscale group-hover:grayscale-0"
                                />
                            </div>
                            <div className="p-6 flex flex-col flex-1">
                                <div className="flex items-center justify-between mb-3">
                                    <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-primary">
                                        {a.category}
                                    </span>
                                    <span className="text-[10px] font-mono uppercase tracking-widest text-foreground/50">
                                        {a.readTime}
                                    </span>
                                </div>
                                <h3 className="text-xl sm:text-2xl font-black tracking-tight mb-3 group-hover:text-primary transition-colors leading-tight">
                                    {a.title}
                                </h3>
                                <p className="text-sm text-foreground/70 leading-relaxed flex-1 mb-4">{a.excerpt}</p>
                                <span className="inline-flex items-center gap-1 text-xs font-mono uppercase tracking-widest">
                                    Read article <ArrowUpRight className="h-3 w-3" />
                                </span>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};
